export const enum EBookingStatus {
  DRAFT = 'drafting',
  NEGOTIATION = 'negotiating',
  RESERVED = 'reserved',
  CANCELED = 'canceled',
  ONGOING = 'ongoing',
  COMPLETED = 'completed',
}
